import * as Yup from "yup";
import { useFormik } from "formik";
import { formatTimeFromDate } from "../../../../../../util/date";
import { Kursushold } from "../../../../../../interfaces/schema";
import { getChangedFields } from "../../../../../../util/common";
import { UseMutateFunction } from "@tanstack/react-query";

export const useKursusoplysningerFormik = (
  initialValues: Kursushold,
  mutate: UseMutateFunction<
    unknown,
    { status: number },
    Record<string, any>,
    unknown
  >,
) =>
  useFormik({
    initialValues,
    validationSchema: Yup.object({
      navn: Yup.string().required("Navn krævet"),
      fraDato: Yup.string().required("Startdato krævet"),
      tilDato: Yup.string().required("Slutdato krævet"),
      fraKlDag: Yup.string().required("Starttidspunkt krævet"),
      tilKlDag: Yup.string().required("Sluttidspunkt krævet"),
      pris: Yup.number()
        .nullable()
        .typeError("Pris skal være et tal")
        .min(0, "Pris skal være positiv"),
    }),
    onSubmit: async (values) => {
      const changedFields = getChangedFields(values, initialValues);
      if (Object.keys(changedFields).length > 0) {
        const body: Record<string, any> = { ...changedFields };
        Object.keys(body).forEach((key) => {
          if (body[key] === "" && initialValues[key] !== "") {
            body[key] = undefined;
          }
        });
        if (body.hasOwnProperty("fraKlDag")) {
          body["fraKlDag"] = body.fraKlDag
            ? formatTimeFromDate(body.fraKlDag as Date)
            : body.fraKlDag;
        }
        if (body.hasOwnProperty("tilKlDag")) {
          body["tilKlDag"] = body.tilKlDag
            ? formatTimeFromDate(body.tilKlDag as Date)
            : body.fraKlDag;
        }
        mutate(body);
      }
    },
    enableReinitialize: true,
  });
